import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { FormService } from '../form.service';
import { BaseControlValueAccessorComponent } from '../inputs/base-control-value-accessor/base-control-value-accessor.component';

@Component({
  selector: 'app-document-acceptance',
  templateUrl: './document-acceptance.component.html',
  styleUrls: ['./document-acceptance.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DocumentAcceptanceComponent),
      multi: true,
    },
  ],
})
export class DocumentAcceptanceComponent extends BaseControlValueAccessorComponent implements OnInit {
  @Input() title!: string;
  @Input() lead: string | null | undefined;
  @Input() link!: string | undefined;
  @Input() required!: boolean;
  @Input() formControl = new UntypedFormControl();

  isAccepted = false;

  constructor(public formService: FormService) {
    super();
  }

  ngOnInit(): void {
    if (this.formControl.value) {
      this.isAccepted = this.formControl.value;
    }
    this.setValidatorToFormControls();
  }

  onAcceptanceChange(): void {
    if (this.formControl.disabled) {
      return;
    }
    if (this.formControl.untouched) {
      this.formControl.markAsTouched();
    }

    this.isAccepted = !this.isAccepted;
    this.formControl.setValue(this.isAccepted);
  }

  private setValidatorToFormControls(): void {
    if (this.required) {
      this.title = this.title + ' *';
    }
  }
}
